import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Carousel } from '../../../../components/ui';
import { ContextPerson } from '../../../../store/contexts/contextPerson';
import ModalitySlide from './components/ModalitySlide/ModalitySlide';
import styles from './SupplierCallout.module.css';

const MODALITIES = [
  {
    key: 'sebraetec',
    title: 'SEBRAETEC',
    body: 'SEBRAETEC_HOME_INFO',
    knowMoreHref: '/sebraetec',
    capitalize: true
  },
  {
    key: 'cursos',
    title: 'ONLINE_COURSES_TITLE',
    body: 'ONLINE_COURSES_HOME_INFO',
    knowMoreHref: '/cursos-online',
    capitalize: true
  },
  {
    key: 'consultoria',
    title: 'CONSULTING_TITLE',
    body: 'CONSULTANCY_HOME_INFO',
    capitalize: true
  },
  {
    key: 'eventos',
    title: 'COURSE_PRESENCIAL_EVENTS_CARD',
    body: 'COURSE_PRESENCIAL_EVENTS_CARD_HOME_INFO',
    requiresPresencial: true
  },
  {
    key: 'saas',
    title: 'SAAS',
    body: 'SAAS_HOME_INFO',
    knowMoreHref: '/solucao-inteligente',
    capitalize: true
  }
];

function SupplierCallout() {
  const { t } = useTranslation('home');
  const { habilitarCursosPresenciais } = useContext(ContextPerson);

  const modalities = MODALITIES.filter(
    m => !m.requiresPresencial || habilitarCursosPresenciais
  );

  return (
    <section className={styles.root}>
      <div className={styles.bg} aria-hidden='true' />

      <div className={`ui-container ${styles.content}`}>
        <div className={styles.intro}>
          <h2 className={styles.title}>{t('SUPPLIER_INTRO_TITLE')}</h2>
          <p className={styles.text}>{t('SUPPLIER_INTRO_P1')}</p>
          <p className={styles.text}>{t('SUPPLIER_INTRO_P2')}</p>
        </div>

        <div className={styles.carousel}>
          <Carousel
            className={styles.carouselInner}
            prevLabel={t('SUPPLIER_PREV')}
            nextLabel={t('SUPPLIER_NEXT')}>
            {modalities.map(m => (
              <ModalitySlide
                key={m.key}
                title={m.title}
                body={m.body}
                knowMoreHref={m.knowMoreHref}
                capitalize={m.capitalize}
              />
            ))}
          </Carousel>
        </div>
      </div>
    </section>
  );
}

export default SupplierCallout;
